<template>
  <div class="change-dorm">
    <!-- 编辑表单 -->
    <el-dialog :title="'当前宿舍：' + dormInfo.blockName + dormInfo.dormName" :visible="changeShow" @close="dialogClose"
      @open="dialogOpen">
      <el-table ref="multipleTable" :data="dormitoryChangeData" tooltip-effect="dark" style="cursor: pointer;width: 100%"
        highlight-current-row @current-change="handleCurrentChange" class="common-edit-button">
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column prop="blockName" label="宿舍楼名字" :show-overflow-tooltip="true" width="200px">
        </el-table-column>
        <el-table-column prop="dormName" label="宿舍编号" :show-overflow-tooltip="true" width="150px">
        </el-table-column>
        <el-table-column prop="level" label="楼层" :show-overflow-tooltip="true" width="150px">
        </el-table-column>
        <el-table-column label="宿舍规格" :show-overflow-tooltip="true" width="150px">
          <template slot-scope="scope"> {{ scope.row.dormType }}人间 </template>
        </el-table-column>
        <el-table-column prop="collect" label="入住人数" :show-overflow-tooltip="true">
        </el-table-column>
      </el-table>
      <div class="form-btn">
        <el-button @click="dialogClose">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ["dormitoryChangeData", "changeShow", "dormInfo"],
  inject: ["refresh"],
  data() {
    return {
      currentData: null
    };
  },
  methods: {
    handleCurrentChange(e) {
      // console.log(e);
      this.currentData = e;
    },
    dialogOpen() {
    },
    dialogClose() {
      this.$emit("update:changeShow", false);
    },
    confirm() {
      if (this.dormInfo.id == this.currentData.id) return this.$message.warning("只能交换到不同宿舍");
      let data = {
        "firstDormId": this.dormInfo.id,
        "secondDormId": this.currentData.id
      };
      this.put(this.$url.changeDormStudent, data).then(res => {
        if (res.code !== 200) return this.$message.error(res.msg);
        this.$message.success(res.msg);
        this.dialogClose();
        this.refresh();
      })
    },
  },
};
</script>

<style scoped lang="scss">
@import "./change-dorm.scss";
</style>
